export const statuses = [
  {
    value: 1,
    label: "Родственник"
  },
  // {
  //   value: 2,
  //   label: "Друг"
  // },
  // {
  //   value: 3,
  //   label: "Публичное лицо"
  // }
]

export const cities = [
  {
      value: "Москва",
      label: "Москва"
  },
  {
      value: "Санкт-Петербург",
      label: "Санкт-Петербург"
  },
  {
      value: "Новосибирск",
      label: "Новосибирск"
  },
  {
      value: "Екатеринбург",
      label: "Екатеринбург"
  },
  {
      value: "Казань",
      label: "Казань"
  },
  {
      value: "Нижний Новгород",
      label: "Нижний Новгород"
  },
  {
      value: "Челябинск",
      label: "Челябинск"
  },
  {
      value: "Самара",
      label: "Самара"
  },
  {
      value: "Омск",
      label: "Омск"
  },
  {
      value: "Ростов-на-Дону",
      label: "Ростов-на-Дону"
  }
];

export const animalStatus = [
  {
    value: 1,
    label: "Питомец"
  },
]
